<template>
  <div id="container">
    <div class="contact-item">
      <span class="title">Merch Support: </span><span class="info">support@goodmerchonly.com
    </span></div>
    <div class="contact-item">
      <span class="title">Band: </span><span class="info">contact@goodkidofficial.com
    </span></div>
    <div class="contact-item">
      <span class="title">Management: </span><span class="info"> contact@goodpeopleonly.com
    </span></div>
    <div class="contact-item">
      <span class="title">Send Us Letters: </span><span class="info">
      Jacob Tsafatinos PO Box 65039 TORONTO RPO CHESTER, ON, M4K 3Z2
    </span></div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAt } from "@fortawesome/free-solid-svg-icons";
library.add(faAt);

export default {
  props: {
    skipTitle: Boolean,
  },
};
</script>

<style scoped>

.contact-item {
  margin-bottom: 3px;
}

.title {
  font-weight: 500;
}

.info {
  font-weight: 300;
  margin-left: 5px;
}

.at-icon {
  height: 11px;
}
</style>
